export { EventCategories, type EventCategory } from './base';

import { AuthEvents } from './auth-events';
import { EmployeeEvents } from './employee-events';
import { FoodWasteEvents } from './food-waste-events';
import { KitchenEvents } from './kitchen-events';
import { LandingEvents } from './landing-events';
import { MenuEvents } from './menu-events';
import { OnboardingEvents } from './onboarding-events';
import { OrderEvents } from './order-events';
import { PushEvents } from './push-events';
import { PWAEvents } from './pwa-events';
import { UIEvents } from './ui-events';

export const EventDefinitions = {
  ...AuthEvents,
  ...OnboardingEvents,
  ...MenuEvents,
  ...OrderEvents,
  ...EmployeeEvents,
  ...KitchenEvents,
  ...LandingEvents,
  ...PushEvents,
  ...UIEvents,
  ...PWAEvents,
  ...FoodWasteEvents,
} as const;

// Extract the event names and their properties
export type EventDefinitions = typeof EventDefinitions;
export type EventName = keyof EventDefinitions;
export type EventProperties<T extends EventName> = EventDefinitions[T]['properties'];
